import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  booleanAttribute,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { IconName } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'sigecom-item-selected-list',
  template: `
    <div class="w-full h-full rounded-lg p-4 border border-[#7A7A7A] space-y-2">
      <div *ngIf="!hasHeadButton else headButton" class="flex justify-between items-center gap-1">
        <h3 class="font-bold text-sm">{{ label }}</h3>
        <span class="font-semibold text-[#7A7A7A] text-sm">
          {{
            selectedItems.length +
              '/' +
              (qtdMaxItems ? qtdMaxItems : itemsLength)
          }}
        </span>
      </div>
      <ng-template #headButton >
        <div class="flex justify-between items-center gap-1">
          <div class="flex">
            <h3 class="font-bold text-sm">{{ label }}</h3>
            <span class="font-semibold text-[#7A7A7A] text-sm">
              {{
                selectedItems.length +
                '/' +
                (qtdMaxItems ? qtdMaxItems : itemsLength)
              }}
            </span>
          </div>
          <sigecom-button [title]="headButtonTitle || 'Remover todos'" (buttonClicked)="headButtonFn.emit()"/>
        </div>
      </ng-template>

      <div class="overflow-y-auto max-h-[19rem]">
        <sigecom-list-container
          *ngIf="dragEnabled"
          class="flex flex-col gap-2"
          cdkDropList
          (cdkDropListDropped)="onDrop($event)"
        >
          <sigecom-list-item outline *ngFor="let item of selectedItems" cdkDrag>
            <div class="flex items-center justify-between">
              <div class="flex flex-col">
                <p class="text-[#012169] font-bold">
                  {{ item.estTxNome || item.label || item.nome || item.insTxResumo }}
                </p>
                <p
                  class="text-[#787878] text-sm"
                  *ngIf="item.insTxResumo && (item.estTxNome || item.label || item.nome)"
                >
                  Participante: {{ item.insTxResumo }}
                </p>
                <p *ngIf="showInscriptionLine" class="text-[#787878] text-sm">
                  Inscrição:
                  {{ item.id?.toString() || item.insNrId?.toString() || '' }}
                </p>
              </div>

              <sigecom-menu-bar>
                <!-- <div
                  *ngIf="showSwitch && !disabled"
                  class="flex gap-1 flex-col items-center"
                >
                  <p class="text-xs">{{ switchLabel }}</p>
                  <sigecom-switch
                    [(switchState)]="item.isCabecaChave"
                    (switchStateChange)="toggleSwitch(item)"
                  />
                </div>

                <ng-container
                  *ngTemplateOutlet="customIcons; context: { $implicit: item }"
                ></ng-container> -->

                <sigecom-menu-bar-item
                  icon="trash"
                  color="sigecom-danger"
                  title="Remover"
                  size="lg"
                  *ngIf="!disabled"
                  (clickAction)="removeItem(item)"
                />
              </sigecom-menu-bar>
            </div>
          </sigecom-list-item>
        </sigecom-list-container>

        <sigecom-list-container
          *ngIf="!dragEnabled"
          class="flex flex-col gap-2"
        >
          <sigecom-list-item outline *ngFor="let item of selectedItems">
            <div class="flex items-center gap-2">
              <div *ngIf="iconItemDisableFn(item)" class="{{ classIconItem }}">
                <sigecom-menu-bar-item
                  [icon]="iconItemName"
                  [color]="iconItemColor"
                />
              </div>
              <div class="flex flex-col flex-1">
                <p class="text-[#012169] font-bold">
                  {{ item.estTxNome || item.label || item.nome || item.insTxResumo }}
                </p>
                <p
                  class="text-[#787878] text-sm"
                  *ngIf="item.insTxResumo && (item.estTxNome || item.label || item.nome)"
                >
                  Participante: {{ item.insTxResumo }}
                </p>
                <p *ngIf="showInscriptionLine" class="text-[#787878] text-sm">
                  Inscrição:
                  {{ item.id?.toString() || item.insNrId?.toString() || '' }}
                </p>
              </div>

              <sigecom-menu-bar>
                <!-- <div
                  *ngIf="
                    showSwitch &&
                    !disabled &&
                    item.claBlClassificado === undefined
                  "
                  class="flex gap-1 flex-col items-center"
                >
                  <p class="text-xs">{{ switchLabel }}</p>
                  <sigecom-switch
                    [(switchState)]="item.isCabecaChave"
                    (switchStateChange)="toggleSwitch(item)"
                  />
                </div> -->

                <ng-container
                  *ngTemplateOutlet="customIcons; context: { $implicit: item }"
                ></ng-container>

                <sigecom-menu-bar-item
                  icon="trash"
                  color="sigecom-danger"
                  title="Remover"
                  size="lg"
                  *ngIf="!disabled"
                  (clickAction)="removeItem(item)"
                />
              </sigecom-menu-bar>
            </div>
          </sigecom-list-item>
        </sigecom-list-container>

        <div
          class="h-full flex justify-center items-center"
          [ngClass]="{ 'text-sigecom-danger font-bold': messageIsAlert }"
          *ngIf="selectedItems.length == 0"
        >
          <p>{{ emptyListMessage }}</p>
        </div>
      </div>
    </div>
  `,
})
export class ItemSelectedListComponent {
  //mensagem de lista vazia
  @Input({ required: true }) emptyListMessage!: string;
  //se a mensagem de lista vazia é um alerta
  @Input({ transform: booleanAttribute }) messageIsAlert = false;

  @Input() selectedItems: any[] = [];
  //@Input() items: any[] = [];
  @Input({ transform: booleanAttribute }) hasHeadButton = false;
  @Input() headButtonTitle?: string;
  @Output() headButtonFn = new EventEmitter<any>()
  @Input() disabled: boolean = false;
  @Input() label: string = '';
  @Input() showSwitch: boolean = false;
  @Input() showInscriptionLine: boolean = true;
  @Input() switchLabel: string = 'Ativo';
  @Input() dragEnabled: boolean = false;
  @Input() iconItemDisableFn: (item: any) => boolean = () => false;
  @Input() classIconItem: string = '';
  @Input() iconItemName?: IconName;
  @Input() iconItemColor: string = '';
  @Input() qtdMaxItems?: number;

  @Output() switchChange = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();
  @Output() selectedItemsCountChange = new EventEmitter<number>();

  @ContentChild('customIcons', { static: false })
  customIcons!: TemplateRef<any>;

  itemsFirstChange = true;
  itemsLength?: number;

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes[`items`] && this.itemsFirstChange) {
  //    // this.items = changes[`items`].currentValue;
  //    // this.itemsLength = this.items.length;
  //     this.itemsFirstChange = false;
  //     this.emitCount();
  //   }
  // }

  toggleSwitch(item: any) {
    this.switchChange.emit(item);
  }
  private emitCount() {
    this.selectedItemsCountChange.emit(this.selectedItems.length);
  }

  removeItem(item: any) {
    this.remove.emit(item);
    this.emitCount();
  }
  onDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.selectedItems,
      event.previousIndex,
      event.currentIndex,
    );
  }
}
